/**
 * Payment Type Context DTO for use with {@link PaymentService}.
 * Represents REST response body of shop-service payment-type-allowed endpoint.
 * @property {number} id - ID of this payment type
 * @property {string} ofsId - OFS ID of this payment type
 * @property {boolean} cvvRequired - Flag indicating if the CVV is required. Used for credit cards
 * @property {boolean} blocked - Flag indicating whether this payment type is blocked
 * @property {string} processorCode - Processor code for this payment type
 * @property {string} formName - Name of the form to be used with this payment type
 * @property {string} paymentClass - Class of this payment type: "CASH", "CCARD", "COMPANYCREDIT", "WIRE", "DIRECTDEBIT", "PAYD"
 * @property {string} ccImageUrl - Url of the credit card image associated with this payment type
 * @property {string} merchantId - Merchant ID associated with this payment type
 * @property {string} localizedName - Localized name of this payment type
 * @property {boolean} installmentsAllowed - Flag indicating whether installments are allowed
 * @property {Array.<number>} installmentNumbers - Available installment counts
 * @property {number} minimumInstallmentAmount - Minimum installment amount
 * @property {number} simulateWhenNumberGT -
 * @property {boolean} binListInstallmentCheck -
 * @property {boolean} disabled - Flag indicating whether this payment type is disabled
 * @see PaymentService
 */
class PaymentTypeContextDto {
    constructor(data = {}) {
        this.id = data.id;
        this.ofsId = data.ofsId;
        this.cvvRequired = data.cvvRequired || false;
        this.blocked = data.blocked || false;
        this.processorCode = data.processorCode;
        this.formName = data.formName;
        this.paymentClass = data.paymentClass;
        this.ccImageUrl = data.ccImageUrl;
        this.merchantId = data.merchantId;
        this.localizedName = data.localizedName || '';
        this.installmentsAllowed = data.installmentsAllowed || false;
        this.installmentNumbers = data.installmentNumbers || [];
        this.minimumInstallmentAmount = data.minimumInstallmentAmount;
        this.simulateWhenNumberGT = data.simulateWhenNumberGT;
        this.binListInstallmentCheck = data.binListInstallmentCheck;
        this.disabled = data.disabled;
    }
}

export default PaymentTypeContextDto;
